import React from "react";
import styled, { keyframes } from "styled-components";

export interface LoaderProps {
    size?: "sm" | "md" | "lg";
    color?: string;
    height?: number | string;
    width?: number | string;
    viewBox?: string;
}

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const LoaderRoot = styled.div<LoaderProps>`
    border: 3px solid ${({ theme, color }) => color || theme.palette.lightGrey};
    border-top: 3px solid ${({ theme, color }) => color || theme.palette.primary};
    border-radius: 50%;
    width: ${({ size }) => {
        if (size === "sm") return "1rem";
        if (size === "lg") return "3rem";
        return "2rem";
    }};
    height: ${({ size }) => {
        if (size === "sm") return "1rem";
        if (size === "lg") return "3rem";
        return "2rem";
    }};
    animation: ${spin} 1s linear infinite;
`;

export const Loader: React.FC<LoaderProps> = ({ size = "md", color }) => {
    return <LoaderRoot size={size} color={color} />;
};

export default Loader;


